import React, { useEffect } from 'react';

interface SidebarAdProps {
  slot?: string;
  className?: string;
  format?: string;
}

const SidebarAd: React.FC<SidebarAdProps> = ({ 
  slot = "1519579735", 
  className,
  format = "vertical"
}) => {
  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.warn("Adsense error:", e);
    }
  }, []);

  // Calculate dimensions based on format
  const adDimensions = format === "vertical" 
    ? { width: "160px", height: "600px" }
    : { width: "300px", height: "250px" };

  return (
    <div 
      className={`sticky top-24 overflow-hidden ${className || ''}`}
      style={{
        width: adDimensions.width,
        height: adDimensions.height,
        minWidth: adDimensions.width,
        minHeight: adDimensions.height
      }}
    >
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-6338038731129939"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="false"
      />
    </div>
  );
};

export default SidebarAd;